__turbopack_context__.v({
  "accordion-trigger": "_9Wlxja_accordion-trigger",
  "chip": "_9Wlxja_chip",
  "placeholder": "_9Wlxja_placeholder",
  "radio-button": "_9Wlxja_radio-button",
});
